import { Accordion, GridContainer } from "@fluidattacks/design";
import _ from "lodash";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { Detail } from "../../detail";
import type { IReAttacksDetailsProps } from "../../types";
import { Value } from "../../value";

const ReAttacksDetailsSection: React.FC<IReAttacksDetailsProps> = ({
  vulnerabilityAdditionalInfo,
  vulnerability,
}: IReAttacksDetailsProps): JSX.Element => {
  const { t } = useTranslation();

  const getVerificationStatus = (status: string | null | undefined): string => {
    const statusDict: Record<string, string> = {
      MASKED: t("searchFindings.tabVuln.masked"),
      ON_HOLD: t("searchFindings.tabVuln.onHold"),
      REQUESTED: t("searchFindings.tabVuln.requested"),
      VERIFIED: t("searchFindings.tabVuln.verified"),
    };

    if (_.isNil(status) || _.isEmpty(status) || status === "NOT_REQUESTED") {
      return "";
    }

    return statusDict[status] ?? status;
  };

  const lastRequestedReattackDate =
    vulnerabilityAdditionalInfo?.lastRequestedReattackDate ?? "";

  return (
    <Accordion
      items={[
        {
          description: (
            <GridContainer
              gap={0.75}
              justify={"space-between"}
              lg={2}
              md={2}
              sm={1}
              xl={2}
            >
              <Detail
                field={
                  <Value
                    placeHolder={t("searchFindings.tabVuln.notRequested")}
                    value={getVerificationStatus(vulnerability.verification)}
                  />
                }
                label={t("searchFindings.tabVuln.vulnTable.reattackStatus")}
              />
              <Detail
                field={
                  <Value value={lastRequestedReattackDate.split(" ")[0]} />
                }
                label={t("searchFindings.tabVuln.vulnTable.lastRequestedDate")}
              />
              <Detail
                field={
                  <Value
                    value={vulnerabilityAdditionalInfo?.lastReattackRequester}
                  />
                }
                label={t("searchFindings.tabVuln.vulnTable.requester")}
              />
              <Detail
                field={<Value value={vulnerabilityAdditionalInfo?.cycles} />}
                label={t("searchFindings.tabVuln.vulnTable.cycles")}
              />
              <Detail
                field={<Value value={vulnerabilityAdditionalInfo?.efficacy} />}
                label={t("searchFindings.tabVuln.vulnTable.efficacy")}
              />
            </GridContainer>
          ),
          expanded: true,
          title: t("searchFindings.tabVuln.vulnTable.reattackDetails"),
        },
      ]}
    />
  );
};

export { ReAttacksDetailsSection };
